/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export enum UseMethod {
  Burn,
  Multiple,
  Single,
}

export type UseMethodArgs = UseMethod;

export function getUseMethodEncoder(): FixedSizeEncoder<UseMethodArgs> {
  return getEnumEncoder(UseMethod);
}

export function getUseMethodDecoder(): FixedSizeDecoder<UseMethod> {
  return getEnumDecoder(UseMethod);
}

export function getUseMethodCodec(): FixedSizeCodec<UseMethodArgs, UseMethod> {
  return combineCodec(getUseMethodEncoder(), getUseMethodDecoder());
}
